import { MCLogger, ConsoleTransport } from '@mc/logger';

const loggerTransports = {
  test: [new ConsoleTransport()],
  production: [],
  development: [new ConsoleTransport()],
};

const initMcLogger = () => {
  const ENV = process.env.GATSBY_PROJECT_ENV !== 'prod' ? 'development' : 'production';
  MCLogger.init({
    platform: 'NottaWebsite',
    env: ENV,
    transports: loggerTransports[ENV],
    privateFieldNames: ['password', 'stripe_payment_info', 'card_id'],
  });
};

export default initMcLogger;
